import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Rating, FieldsFeedback } from '@app/_models/feedback';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { FeedbackService } from '@app/services/feedback.service';
import { FeedbackDataSource } from '@app/services/feedback.datasource';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialog } from '../feedback-dialog/feedbackDialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'feedbackMain',
  templateUrl: './feedbackMain.component.html',
  styleUrls: ['./feedbackMain.component.scss']
})
export class FeedbackMain implements OnInit {
  ratingList: Array<Rating>;
  fieldsFeedback: Array<FieldsFeedback>;
  feedbackList: FeedbackDataSource;
  fromDate: string = '';
  fromDateControl = new FormControl();
  toDate: string = '';
  toDateControl = new FormControl();
  displayedColumns: string[] = ['name', 'phone', 'comment', 'reservation', 'options'];
  resultsLength: number = 0;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private feedbackService: FeedbackService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.feedbackService.getRatings(this.fromDate, this.toDate).subscribe((res) => {
      this.ratingList = res;
    });
    this.feedbackService.getFeedbackFieldsAvg(this.fromDate, this.toDate).subscribe((res) => {
      this.fieldsFeedback = res;
    });
    this.feedbackList = new FeedbackDataSource(this.feedbackService);
    this.feedbackList.loadFeedbacks(this.fromDate, this.toDate).then((total:number) => {
      this.resultsLength = total;
    });
  }

  ngAfterViewInit() {
    this.paginator.page
      .pipe(
        tap(() => this.feedbackList.loadFeedbacks(this.fromDate, this.toDate, 'user', this.paginator.pageIndex, this.paginator.pageSize))
      )
      .subscribe();
  }

  viewFeedback(ev, feedbacks, name) {
    const dialogRef = this.dialog.open(FeedbackDialog, {
      width: '500px',
      data: { feedbacks, name },
    });
  }

  applyNewFilters() {
    this.toDate = this.toDateControl.value ? moment(this.toDateControl.value._d).toISOString() : '';
    this.fromDate = this.fromDateControl.value ? moment(this.fromDateControl.value._d).toISOString() : '';
    this.feedbackService.getRatings(this.fromDate, this.toDate).subscribe((res) => {
      this.ratingList = res;
    });
    this.feedbackService.getFeedbackFieldsAvg(this.fromDate, this.toDate).subscribe((res) => {
      this.fieldsFeedback = res;
    });
    this.feedbackList.loadFeedbacks(this.fromDate, this.toDate, 'user', this.paginator.pageIndex, this.paginator.pageSize).then((total:number) => {
      this.resultsLength = total;
    });
  }

}
